import Model from '../model'
import shortid from 'shortid'

class Block extends Model {

  constructor(block) {
    super()
    this.uid = (block && block.uid) || shortid.generate()
  }

}

export default Block



// WEBPACK FOOTER //
// ./src/models/blocks/block.js